import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Instrument } from '../dto/instrument';
import { CrudService, Filter, FilterOperator } from '@mango/core';
import { Relatie } from '../dto/relatie';
import { map } from 'rxjs/operators';
import { Contactpersoon } from '../dto/contactpersoon';
import { DocumentDownloadResponse } from './projectregel.service';
import { instrumentRelatie } from '../dto/instrumentrelatie';
import { InstrumentComponent } from 'src/app/cij/instrument/instrument/instrument.component';

interface DownloadCsvResponse {
    data: string;
}

@Injectable({ providedIn: 'root' })
export class InstrumentService extends CrudService<Instrument> {

    constructor(injector: Injector) { super(Instrument, injector); }

    getRelatieFilter(relatie: Relatie): Filter<Instrument> {
        if (relatie != null) {
            return new Filter<Instrument>(fb => [fb.equal("relatie",relatie.id)]);
        }
        else {
            return new Filter<Instrument>(fb => [fb.equal("relatie",-1)]);
        }
    }

    getRelatieFilterNoBarcode(relatie: Relatie): Filter<Instrument> {
        if (relatie != null) {
            return new Filter<Instrument>(fb => [fb.equal("relatie",relatie.id), fb.equal("nr_Barcode",null), fb.equal("isVervallen",false)]);
        }
        else {
            return new Filter<Instrument>(fb => [fb.equal("relatie",-1), fb.equal("nr_Barcode",null), fb.equal("isVervallen",false)]);
        }
    }
    
    getWerkstandaardFilter(): Filter<Instrument> {
        return new Filter<Instrument>(fb => [fb.equal("isVervallen",false), fb.equal("isWerkstandaard",true)]);
    }

    // separate path, because the generic crud controller doesn't support extra POST parameters
    setBarcode(instrumentId: number, barcode: string) {
        let query: string = `api/dto/instrument/setBarcode?instrumentId=${instrumentId}&barcode=${barcode}`;
        return this.http.post(query, null).pipe(map(x => x as SetBarcodeResponse));        
    }
    
    bijwerkenInstrument(contactpersoon: Contactpersoon) {
        let query: string = `api/dto/instrument/BijwerkenInstrument?contactpersoonId=${contactpersoon.id}`;

        return this.http.post(query, null).pipe(map(x => x as InstrumentResponse));

    }  

    verversenInstrument(Id: number) {
        let query: string = `api/dto/instrument/VerversenInstrument?instrumentId=${Id}`;

        return this.http.post(query, null).pipe(map(x => x as InstrumentResponse));

    } 

    exporterenCentix(id: Number) {
        let query: string = `/api/dto/instrument/ExportInstrumentCentix?instrumentId=${id}`;
        return this.http.post(query, null).pipe(map(x => x as InstrumentResponse));
    }

    ChangeCentixId(instrumentId: number, centixId: number) {
        let query: string = `/api/dto/instrument/ChangeCentixId?instrumentId=${instrumentId}&centixId=${centixId}`;

        return this.http.post(query, null).pipe(map(x => x as InstrumentResponse));

    }

    changeRelatie(items: Instrument[], relatieId: number) {
        
        var instrumenten = [];
        // Items are not real instruments, translate and id's only
        items.forEach(item => {
            var i = new Instrument();
            i.id = item.id;
            i.centixId = item.centixId;
            instrumenten.push(i);        
        });           

        var ir = new instrumentRelatie();
        ir.instrumenten = instrumenten;
        ir.relatie = relatieId;
                
        let query: string = `api/dto/instrument/ChangeRelatie`;
        
        return this.http.post(query, ir).pipe(map(x => x as InstrumentResponse));

    }
    
    downloadExcelFile(filter: Filter<Instrument>) {
        
        let f = `filter=${encodeURIComponent(JSON.stringify(this.convertFilter(filter) ))}`;
        let query: string = `/api/dto/instrument/InstrumentExport?${f}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));

    }

    private convertFilter (f: Filter<Instrument>, arr: any[] = [] ) {
        for(let fp of f.getProperties()) {
            arr.push(fp);
        };

        let isEmpty = (str)=>typeof(str)=='string' && str.trim() == "";

        Object.keys(f).forEach(x => {
            if(Object.keys(new Filter<Instrument>()).indexOf(x) === -1 && f[x] != null && !isEmpty(f[x])) {
                let customProperty = {};
                customProperty[x] = f[x];
                arr.push(customProperty);
            }
        });

        f.filters.forEach(subF => {
            let andOrItem = {};
            let subArr = [];
            this.convertFilter(subF, subArr);
            andOrItem[subF.filterOperator == FilterOperator.And ? "and" : "or"] = subArr;
            arr.push(andOrItem);
        });

        return arr;
    }

}

export class SetBarcodeResponse {
    successful: boolean;
}

export class InstrumentResponse {
    successful: boolean;
    message: string;
}